// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Hero Section */
.hero {
  background-color: var(--color-secondary);
  color: var(--color-text-primary);
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  position: relative;
  padding: 2rem 0;
}

.hero-container {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 1rem;
}

/* Hero Text Lines */
.hero-text-line {
  width: 100%;
  overflow: hidden;
  white-space: nowrap;
}

/* Hero scroll uses global .scrolling-text class */

.hero-text {
  font-family: var(--font-family-scrolling);
  font-weight: 900;
  font-size: 8rem;
  letter-spacing: 4px;
  text-transform: uppercase;
  line-height: 1;
}

/* Component-specific letter spacing for hero text */
.hero-text .solid {
  letter-spacing: 4px;
}

.hero-text .outline {
  letter-spacing: 4px;
  font-weight: 400;
}

/* Tagline */
.hero-tagline {
  text-align: center;
  padding: 0 2rem;
}

.hero-tagline p {
  font-size: 1.5rem;
  color: var(--color-primary);
  font-weight: 400;
  line-height: 1.4;
  letter-spacing: 1px;
}

/* Speed control now in global App.css */

/* Responsive Design */
@media (max-width: 1200px) {
  .hero-text {
    font-size: 6rem;
    letter-spacing: 3px;
  }

  .hero-text .solid,
  .hero-text .outline {
    letter-spacing: 3px;
  }
}

@media (max-width: 768px) {
  .hero-text {
    font-size: 4rem;
    letter-spacing: 2px;
  }

  .hero-text .solid,
  .hero-text .outline {
    letter-spacing: 2px;
  }

  .hero-tagline p {
    font-size: 1rem;
  }
}

@media (max-width: 480px) {
  .hero-text {
    font-size: 3rem;
    letter-spacing: 1px;
  }

  .hero-text .solid,
  .hero-text .outline {
    letter-spacing: 1px;
  }

  .hero-tagline p {
    font-size: 0.9rem;
    padding: 0 1rem;
  }
}

@media (max-width: 320px) {
  .hero-text {
    font-size: 3rem;
  }

  .hero-tagline p {
    font-size: 0.8rem;
  }
} `, "",{"version":3,"sources":["webpack://./src/components/Hero/Hero.css"],"names":[],"mappings":"AAAA,iBAAiB;AACjB;EACE,wCAAwC;EACxC,gCAAgC;EAChC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;AACX;;AAEA,oBAAoB;AACpB;EACE,WAAW;EACX,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,kDAAkD;;AAElD;EACE,yCAAyC;EACzC,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;AAChB;;AAEA,oDAAoD;AACpD;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,YAAY;AACZ;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,2BAA2B;EAC3B,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,wCAAwC;;AAExC,sBAAsB;AACtB;EACE;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;;IAEE,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;;IAEE,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;;IAEE,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;IACjB,eAAe;EACjB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;AACF","sourcesContent":["/* Hero Section */\n.hero {\n  background-color: var(--color-secondary);\n  color: var(--color-text-primary);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n  position: relative;\n  padding: 2rem 0;\n}\n\n.hero-container {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 1rem;\n}\n\n/* Hero Text Lines */\n.hero-text-line {\n  width: 100%;\n  overflow: hidden;\n  white-space: nowrap;\n}\n\n/* Hero scroll uses global .scrolling-text class */\n\n.hero-text {\n  font-family: var(--font-family-scrolling);\n  font-weight: 900;\n  font-size: 8rem;\n  letter-spacing: 4px;\n  text-transform: uppercase;\n  line-height: 1;\n}\n\n/* Component-specific letter spacing for hero text */\n.hero-text .solid {\n  letter-spacing: 4px;\n}\n\n.hero-text .outline {\n  letter-spacing: 4px;\n  font-weight: 400;\n}\n\n/* Tagline */\n.hero-tagline {\n  text-align: center;\n  padding: 0 2rem;\n}\n\n.hero-tagline p {\n  font-size: 1.5rem;\n  color: var(--color-primary);\n  font-weight: 400;\n  line-height: 1.4;\n  letter-spacing: 1px;\n}\n\n/* Speed control now in global App.css */\n\n/* Responsive Design */\n@media (max-width: 1200px) {\n  .hero-text {\n    font-size: 6rem;\n    letter-spacing: 3px;\n  }\n\n  .hero-text .solid,\n  .hero-text .outline {\n    letter-spacing: 3px;\n  }\n}\n\n@media (max-width: 768px) {\n  .hero-text {\n    font-size: 4rem;\n    letter-spacing: 2px;\n  }\n\n  .hero-text .solid,\n  .hero-text .outline {\n    letter-spacing: 2px;\n  }\n\n  .hero-tagline p {\n    font-size: 1rem;\n  }\n}\n\n@media (max-width: 480px) {\n  .hero-text {\n    font-size: 3rem;\n    letter-spacing: 1px;\n  }\n\n  .hero-text .solid,\n  .hero-text .outline {\n    letter-spacing: 1px;\n  }\n\n  .hero-tagline p {\n    font-size: 0.9rem;\n    padding: 0 1rem;\n  }\n}\n\n@media (max-width: 320px) {\n  .hero-text {\n    font-size: 3rem;\n  }\n\n  .hero-tagline p {\n    font-size: 0.8rem;\n  }\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
